module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"miniCart":"Warenkorb","viewBag":"Warenkorb","quantity":"Menge","price":"Price","totalPrice":"Gesamtpreis","delete":"Löschen","checkout":"Checkout"},"en":{"miniCart":"Cart","viewBag":"View Bag","quantity":"quantity","price":"Price","totalPrice":"Total","delete":"Delete","checkout":"Checkout"}}')
  delete Component.options._Ctor
}
